import { Box, Unstable_Grid2 as Grid } from "@mui/material";
import { AiFillCopyrightCircle } from "react-icons/ai";
import { BsBoxFill, BsCreditCard2BackFill } from "react-icons/bs";
import { HiShoppingBag } from "react-icons/hi2";
import { IoAlertCircle } from "react-icons/io5";
import { MdOutlinePayments } from "react-icons/md";
import { RiCheckboxCircleFill } from "react-icons/ri";
import Overview from "../../../components/overview/Overview";

function CountToday({ countShipments = {} }) {
  return (
    <section>
      <h4>امروز : {new Date().toLocaleDateString("fa-IR")}</h4>
      <Box sx={{ display: "flex", flexDirection: "row" }} className="mt-5">
        <Grid container spacing={3}>
          <Grid xs={12} sm={6} lg={3}>
            <Overview
              positive
              sx={{ height: "100%" }}
              value={countShipments.all}
              title="ثبت شده"
              backgroundColor="success.main"
            >
              <RiCheckboxCircleFill />
            </Overview>
          </Grid>

          <Grid xs={12} sm={6} lg={3}>
            <Overview
              positive
              sx={{ height: "100%" }}
              value={countShipments.afterRent}
              title="پس کرایه"
              backgroundColor="purple"
            >
              <MdOutlinePayments />
            </Overview>
          </Grid>
          <Grid xs={12} sm={6} lg={3}>
            <Overview
              positive
              sx={{ height: "100%" }}
              value={countShipments.online}
              title=" پرداخت آنلاین"
              backgroundColor="primary.main"
            >
              <BsCreditCard2BackFill />
            </Overview>
          </Grid>
          <Grid xs={12} sm={6} lg={3}>
            <Overview
              positive
              sx={{ height: "100%" }}
              value={countShipments.cod}
              title="COD"
              backgroundColor="purple"
            >
              <AiFillCopyrightCircle />
            </Overview>
          </Grid>
          <Grid xs={12} sm={6} lg={3}>
            <Overview
              positive
              sx={{ height: "100%" }}
              value={countShipments.shop}
              title="آوا شاپ"
              backgroundColor="#ED660F"
            >
              <HiShoppingBag />
            </Overview>
          </Grid>
          <Grid xs={12} sm={6} lg={3}>
            <Overview
              positive
              sx={{ height: "100%" }}
              value={countShipments.box}
              title="آوا باکس"
              backgroundColor="#ED660F"
            >
              <BsBoxFill />
            </Overview>
          </Grid>

          <Grid xs={12} sm={6} lg={3}>
            <Overview
              positive
              sx={{ height: "100%" }}
              value={countShipments.temporarycancelled}
              title="لغو موقت"
              backgroundColor="error.main"
            >
              <IoAlertCircle />
            </Overview>
          </Grid>
        </Grid>
      </Box>
    </section>
  );
}

export default CountToday;
